const legacyWriteText = (str) => {
  const listener = (e) => {
    e.clipboardData.setData("text/plain", str);
    e.preventDefault();
  };
  document.addEventListener("copy", listener);
  document.execCommand("copy");
  document.removeEventListener("copy", listener);
  return Promise.resolve();
};
const copyToClipboard = (text) => navigator.clipboard && window.isSecureContext ? navigator.clipboard.writeText(text) : legacyWriteText(text);
export default copyToClipboard;
